import React from 'react'

const Template = () => {
    return (
        <>
            <section className="content-header">
            <h1>Component Name</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">

                        <div className="panel panel-success panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span>Documents</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <button className="btn btn-warning mr-10">
                                            <span>Save new order</span>
                                        </button>
                                        <button className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                            <span>Create new document</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">PANEL BODY</div>
                            <div className="panel-footer">PANEL FOOTER</div>
                        </div>
                    </div>
                    <div className="box-footer">BOX FOOTER</div>          
                </div>
            </section>
        </>
    )
}

export default Template